import { render, staticRenderFns } from "./mahjongway2.vue?vue&type=template&id=1f8ec0d0&scoped=true"
import script from "./mahjongway2.vue?vue&type=script&lang=js"
export * from "./mahjongway2.vue?vue&type=script&lang=js"
import style0 from "./mahjongway2.vue?vue&type=style&index=0&id=1f8ec0d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8ec0d0",
  null
  
)

export default component.exports